// The Inbox badge: conversations with unread messages, plus application
// threads where it's your move. Every place that refreshes the badge from
// GET /conversations/count goes through here so they agree.
export const inboxBadgeCount = ({unreadCount, waitingCount} = {}) =>
  Number(unreadCount || 0) + Number(waitingCount || 0)
